import { atom } from 'recoil'
import { INews } from '@/components/News/news.types'

const newsAtom = atom<{ news: INews[]; loaded: boolean }>({ default: { news: [], loaded: false }, key: 'news' })
export default newsAtom
